import {operatingSystems} from './constants';

export const getOS = function() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        os = null;
  
    if (operatingSystems.macosPlatforms.indexOf(platform) !== -1) {
      os = operatingSystems.macOS;
    } else if (operatingSystems.iosPlatforms.indexOf(platform) !== -1) {
      os = operatingSystems.iOS;
    } else if (operatingSystems.windowsPlatforms.indexOf(platform) !== -1) {
      os = operatingSystems.windows;
    } else if (/Android/.test(userAgent)) {
      os = operatingSystems.android;
    } else if (!os && /Linux/.test(platform)) {
      os = operatingSystems.linux;
    }
    return os;
  }



// WEBPACK FOOTER //
// ./src/lib/operatingSystem.js